import './page/sellops-order-modification-tracking-list';
import './page/sellops-order-editing-config-redirect';

import enGB from './snippet/en-GB.json';
import deDE from './snippet/de-DE.json';

const { Module } = Shopware;

Module.register('sellops-order-modification-tracking', {
    type: 'plugin',
    name: 'sellops-order-modification-tracking',
    title: 'sellops-order-modification-tracking.general.mainMenuItemGeneral',
    description: 'sellops-order-modification-tracking.general.description',
    color: '#ff6b35',
    icon: 'regular-shopping-bag',

    snippets: {
        'en-GB': enGB,
        'de-DE': deDE,
    },

    navigation: [
        {
            id: 'sellops-order-modification-tracking',
            label: 'sellops-order-modification-tracking.general.mainMenuItemGeneral',
            color: '#ff6b35',
            path: 'sellops.order.modification.tracking.list',
            icon: 'regular-shopping-bag',
            parent: 'sw-order',
            position: 100,
        },
        {
            id: 'sellops-order-editing-config',
            label: 'sellops-order-modification-tracking.general.configMenuLabel',
            color: '#ff6b35',
            path: 'sellops.order.modification.tracking.config',
            icon: 'regular-cog',
            parent: 'sw-order',
            position: 110,
        },
    ],

    routes: {
        list: {
            component: 'sellops-order-modification-tracking-list',
            path: 'list',
            meta: {
                parentPath: 'sw.order.index',
            },
        },
        config: {
            component: 'sellops-order-editing-config-redirect',
            path: 'config',
            meta: {
                parentPath: 'sw.order.index',
            },
        },
    },
});
